import logo from "./logo.svg";
import "./App.css";
import Content from "./component/Content/Content";

function App() {
  return (
    <div className="App">
      <Content />
    </div>
  );
}

export default App;
